const Camera = {};

const useCameraDevice = () => {};

const useCameraPermission = () => ({
    hasPermission: true,
    requestPermission: () => {},
});

const useCodeScanner = () => {};

export { Camera, useCameraDevice, useCameraPermission, useCodeScanner };
